import { getBackendURL, getBackendBaseURL } from '../utils/utils';

export const getSite = async id => {
  const response = await apiFetch(`${getBackendURL()}/site/getSite?id=${id}`);
  return response.json();
};

export const updateSite = async payload => {
  const response = await apiFetch(`${getBackendURL()}/site/updateSite`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  return response.json();
};

export const addSite = async payload => {
  const response = await apiFetch(`${getBackendURL()}/site/add`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  return response.json();
};

export const getSitesByCreator = async (userId, source) => {
  const response = await apiFetch(
    `${getBackendURL()}/site/getSitesByCreator?creator=${userId}&requestSource=${source}`
  );
  return response.json();
};

export const getUser = async id => {
  const response = await apiFetch(`${getBackendURL()}/site/user/?id=${id}`);
  return response.json();
};

export const getTemplates = async () => {
  const response = await apiFetch(`${getBackendURL()}/site/templates`);
  return response.json();
};

export const getMerchants = async (subPath, ownerId) => {
  const response = await apiFetch(
    `${getBackendBaseURL()}/api/${subPath}/merchant/merchants?ownerId=${ownerId}&limit=1000`
  );
  const data = await response.json();
  return data;
};

/**
 * Wrapper around fetch that always includes credentials: 'include'
 * so the http-only session cookie is sent with every API request.
 */
export function apiFetch(url, options = {}) {
  return fetch(url, {
    ...options,
    credentials: 'include',
  });
}
